import { Table, TableColumnsType } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../Button';
import useAxios from '../../../hooks/useAxios';
import config from '../../../lib/config';
import { IBus, IGetBuses } from '../../../models/shuttleSetting.model';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import Pagination from '../../Pagination';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { getBuses } from '../../../api/shuttleSetting.api';
import { ShuttleContents } from '../../../pages/campus/shuttle';
import { useHistory } from 'react-router-dom';
import SelectCampus from '../../SelectCampus';
import useAuth from '../../../hooks/useAuth';

interface IProps {
  setBusCode: (busCode: number | undefined) => void;
  campusDeactived: boolean;
}

const BusList: FC<IProps> = ({ setBusCode, campusDeactived}) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetBuses>();
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (currentCampus) {
      execute(getBuses(currentCampus));
    }
  }, [currentCampus]);

  const columns: TableColumnsType<IBus> = [
    {
      title: t('campus.shuttle.column1'),
      dataIndex: 'busName',
      key: 'busName',
      align: 'center',
      sorter: (a, b) => a.busName?.localeCompare(b.busName),
    },
    {
      title: t('campus.shuttle.column2'),
      dataIndex: 'driverName',
      key: 'driverName',
      align: 'center',
      sorter: (a, b) => a.driverName?.localeCompare(b.driverName),
    },
    {
      title: t('campus.shuttle.column3'),
      dataIndex: 'busNo',
      key: 'busNo',
      align: 'center',
      sorter: (a, b) => a.busNo?.localeCompare(b.busNo),
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <SelectCampus className="w-150p" />
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink"
            onClick={() => history.push(`/campus/shuttle?index=${ShuttleContents.BusCreate}`)}
            text={t('campus.shuttle.button1')}
            writeAuthYn={writeAuthYn}
            disabled={campusDeactived}
          />
        </div>
      </div>
      
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={res?.data}
        pagination={{
          current: page,
          pageSize: config.pageSize,
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              setBusCode(record.busCode);
              history.push(`/campus/shuttle?index=${ShuttleContents.BusRead}`);
            },
          };
        }}
        rowClassName="pointer"
        rowKey="busCode"
      />
      <div className="comm-bx__between">
        <div></div>
        <div className="common-paging center">
          <Pagination
            count={res?.data.length || 0}
            page={page}
            setPage={setPage}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink"
            onClick={() => history.push(`/campus/shuttle?index=${ShuttleContents.BusCreate}`)}
            text={t('campus.shuttle.button1')}
            disabled={campusDeactived}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
    </>
  )
}

export default BusList;
